export default __webpack_public_path__ + "static/business-intelligence-data-analysis-676d870e3b06cf8474a0470f9723faf5.jpg";